/**
 * Page de vue chronologique d'un contact (To Dos + Actions Spontanées).
 */

import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { getContact, getContactTimeline } from "../api/contactApi";
import { formatDate, isOverdue } from "../utils/dateUtils";
import { STATUS_LABELS } from "../utils/constants";
import StatusBadge from "../components/StatusBadge";
import "./ContactTimelinePage.css";
import "./PageStyles.css";

export default function ContactTimelinePage() {
  const { id } = useParams();
  const [contact, setContact] = useState(null);
  const [timeline, setTimeline] = useState([]);

  useEffect(() => {
    loadData();
  }, [id]);

  async function loadData() {
    const [contactData, timelineData] = await Promise.all([
      getContact(id),
      getContactTimeline(id),
    ]);
    setContact(contactData);
    setTimeline(timelineData);
  }

  if (!contact) return <p>Chargement...</p>;

  const fullName = `${contact.first_name || ""} ${contact.last_name || ""}`.trim();

  return (
    <div className="page">
      <div className="page-header">
        <h2>Chronologie : {fullName || "Contact"}</h2>
        <Link to="/contacts" className="btn btn-secondary">
          Retour aux contacts
        </Link>
      </div>
      {contact.company && (
        <p className="timeline-company">{contact.company}</p>
      )}
      <div className="timeline">
        {timeline.length === 0 && (
          <p className="timeline-empty">Aucun événement pour ce contact.</p>
        )}
        {timeline.map((item) => (
          <div key={`${item.type}-${item.id}`} className={`timeline-item timeline-${item.type}`}>
            <div className="timeline-marker" />
            <div className="timeline-content">
              <div className="timeline-header">
                <span className="timeline-date">{formatDate(item.date) || "Sans date"}</span>
                <span className={`timeline-type-badge ${item.type}`}>
                  {item.type === "todo" ? "To Do" : "Action Réalisée"}
                </span>
                {item.type === "todo" && (
                  <StatusBadge
                    value={item.status}
                    label={STATUS_LABELS[item.status]}
                  />
                )}
                {item.type === "todo" && item.status === "in_progress" && isOverdue(item.date) && (
                  <StatusBadge value="overdue" label="En retard" variant="danger" />
                )}
                <span className="timeline-responsable">
                  Responsable : {item.responsable_name || "—"}
                </span>
              </div>
              <p className="timeline-description">{item.description || "—"}</p>
              {item.tags?.length > 0 && (
                <div className="tag-list">
                  {item.tags.map((t) => (
                    <span key={t.id} className="tag-inline">{t.label}</span>
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
